<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <DiscountCodeCreateAndUpdateFormItems :form="form" :data="discountCode" />
    </VForm>
</template>
<script>
import { rootActions, Getters } from '@/store/types'
import DiscountCodeCreateAndUpdateFormItems from '@/components/DiscountCodeCreateAndUpdateFormItems.vue'
import VForm from '@/components/VForm.vue'

export default {
    components: {
        DiscountCodeCreateAndUpdateFormItems,
        VForm,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        discountCode () {
            return this.$store.getters[Getters.discount.GET_DISCOUNT_CODE](this.id)
        },
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.UPDATE_DISCOUNT_CODE, { id: this.id, ...values },
            )
            return res
        },
    },
}
</script>
